import {setCabinetsARBlobUrl} from "../../../../../../actions/sqftFunctions";
import store from "../../../../../../store";

class GLBLoader {
  constructor(glbUrl) {
    this.glbUrl = glbUrl;
    this.loadGLBModel();
  }

  loadGLBModel() {
    const loader = new window.GLTFLoader();
    loader.load(
      this.glbUrl,
      async (gltf) => {

        //create AR
        const exporter = new window.USDZExporter();
        gltf.scene.updateWorldMatrix(false, true);
        const arraybuffer = await exporter.parse( gltf.scene );
        const blob = new Blob( [ arraybuffer ], { type: 'application/octet-stream' } );

        store.dispatch(setCabinetsARBlobUrl(URL.createObjectURL( blob )));
      },
      undefined,
      (error) => console.error(error)
    );
  }
}

export default GLBLoader;
